<template>
  <div class="hero">
    <!-- The center container -->
    <v-container>
      <v-row>
        <!-- Left column -->
        <v-col cols="12" md="7">
          <!-- The title -->
          <div
            class="hero__title"
            v-vue-aos.once="{ animationClass: 'fadeIn slower animated' }"
          >
            <!-- The <span>#1</span> <br />
            Influencers <br />
            Management Tool -->
            Influencer <span>Marketing</span> Much?
          </div>

          <!-- The text -->
          <div
            class="hero__text mt-6"
            v-vue-aos.once="{ animationClass: 'fadeIn slow animated delay-1s' }"
          >
            The Most Scaled and Powerful Influencer Marketing Intelligence Platform
          </div>

          <!-- The text -->
          <div
            class="hero__text mt-3"
            v-vue-aos.once="{ animationClass: 'fadeIn slow animated delay-1s' }"
          >
            Think Like Media, Define Audiences and Find the the Real and Relevant Influencers with the right Reach and Resonance
          </div>

          <!-- The text -->
          <div
            class="hero__text mt-3"
            v-vue-aos.once="{ animationClass: 'fadeIn slow animated delay-1s' }"
          >
          Get up to 80% Efficiency on your current efforts on Day 1
          </div>

          <!-- The buttons -->
          <div
            class="d-flex mt-12"
            v-vue-aos.once="{ animationClass: 'fadeInUp animated delay-2s' }"
            @animationend="$emit('animationEnd')"
          >
            <v-btn
              large
              depressed
              class="primary mr-3 mr-md-4"
              href="/#contact"
            >
              Demo Request
            </v-btn>

            <v-btn
              dark
              large
              depressed
              class="bluegray"
              :to="{ name: 'Register' }"
            >
              Sign Up
            </v-btn>
          </div>
        </v-col>

        <!-- Right column -->
        <v-col
          cols="12"
          md="5"
          v-vue-aos.once="{ animationClass:'fadeIn slow animated delay-1s' }"
        >
          <lottie-animation
            loop
            v-prlx
            :animationData="require('@/json/animations/social-media-woman.json')"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// Import children components
import LottieAnimation from 'lottie-web-vue'

// Export the SFC
export default {
  // Name of the component
  name: "Hero",

  // Register components
  components: {
    LottieAnimation
  }
}
</script>

<style lang="stylus" scoped>
.hero
  padding-top 10em
  padding-bottom 5em
  min-height 100vh
  background linear-gradient(290deg, #000000 0.36%, #373B56 100%)

  &__title
    font-weight bold
    font-size 4.75em
    line-height 1.2
    color #fff

    span
      background linear-gradient(160deg, #F05D56 0%, #F07D76 160%)
      -webkit-background-clip text
      -webkit-text-fill-color transparent
      background-clip text
      text-fill-color transparent

  &__text
    font-size 1.2em
    font-weight 100
    color #fff
</style>
